var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoundicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83594 0.421875C5.41406 0.421875 5.94792 0.484375 6.4375 0.609375C6.92708 0.729167 7.36719 0.877604 7.75781 1.05469L7.15625 2.47656C6.81771 2.32552 6.46094 2.19792 6.08594 2.09375C5.71094 1.98438 5.33333 1.92969 4.95312 1.92969C4.46354 1.92969 4.07292 2.0651 3.78125 2.33594C3.49479 2.60156 3.35156 3.04167 3.35156 3.65625V5.53125H6.44531V6.88281H3.35156V8.3125C3.35156 8.71875 3.29427 9.05729 3.17969 9.32812C3.07031 9.59896 2.92708 9.81771 2.75 9.98438C2.57812 10.1458 2.39583 10.2812 2.20312 10.3906H8.10156V12H0.0078125V10.4766C0.315104 10.3776 0.580729 10.2448 0.804688 10.0781C1.03385 9.91146 1.21094 9.6875 1.33594 9.40625C1.46094 9.125 1.52344 8.76562 1.52344 8.32812V6.88281H0.0546875V5.53125H1.52344V3.57812C1.52344 2.86458 1.66667 2.27604 1.95312 1.8125C2.23958 1.34375 2.63281 0.994792 3.13281 0.765625C3.63281 0.536458 4.20052 0.421875 4.83594 0.421875Z",
    fill: "#050220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoundicon);
export default __webpack_public_path__ + "static/media/poundicon.cfc141db429683277b90b7b569d198cc.svg";
export { ForwardRef as ReactComponent };